<template>
  <div class="p-2">
    <slot />
  </div>
</template>
